export function validateCep(cep: string): boolean {
    cep = cep.replace(/\s/g, '');
  
    const regexCEP = /^\d{5}-\d{3}$|^\d{8}$/;
  
    return regexCEP.test(cep);
  }